import React from 'react';
import { IconButton } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListActionButton = props => {
  const iconForButton = {
    iconName: props.iconName,
    styles: {
      root: {
        width: 18,
        height: 18,
        color: props.iconColor
      }
    }
  };
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(IconButton, {
      "data-id": props.dataId,
      disabled: props.disabled,
      styles: {
        root: {
          padding: 2,
          height: 22,
          width: 22
        }
      },
      iconProps: iconForButton,
      onClick: () => props.onClick(),
      id: props.id
    })
  }, props.index);
};